@if (isSelectionAndEssence()) {
  @if (showEditionAndDate()) {
    @if (article().edition; as edition) {
      <span class="font-bold">
        {{
          'pages.articles.selectionEssenceCommentary.editionPublishedAt'
            | translate
        }}:
      </span>
      <span
        >{{ edition.year }}-{{
          edition.edition_version ?? edition.volume
        }}</span
      >
      <br />
    }
    @if (article().article_type; as articleType) {
      <span class="font-bold"
        >{{ 'pages.articles.articleType' | translate }}:</span
      >
      {{ ' ' }}
      <span>{{ 'articleTypes.' + articleType.name | translate }}</span>
      <br />
    }
    <span class="font-bold">
      {{
        'pages.articles.selectionEssenceCommentary.articlePublishedAt'
          | translate
      }}:
    </span>
    <span>{{ article().published_at | date: 'dd-MM-yyyy' }}</span>
    <br />
  }
  @if (article().groupedUsers?.length) {
    @for (groupedUser of article().groupedUsers; track groupedUser) {
      <div class="mb-2">
        <span class="font-bold">
          {{
            'pages.articles.selectionEssenceCommentary.' + groupedUser.key
              | translate
          }}:{{ ' ' }}
        </span>
        <br />
        @for (user of groupedUser.authors; track user; let lastAuthor = $last) {
          <a
            class="hover:text-primary-text hover:underline"
            [dhpPersonLink]="user"
            (click)="$event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
            tabindex="0"
            role="link"
          >
            {{ user | formatAuthorName }}
          </a>
          {{ !lastAuthor ? ', ' : '' }}
        }
      </div>
    }
  } @else {
    <span>{{ 'pages.articles.author' | translate }}</span>
  }
} @else {
  @if (getAuthors()?.length && getAuthors(); as authors) {
    <span class="font-bold"
      >{{
        (authors.length === 1
          ? 'pages.articles.authorLabel'
          : 'pages.articles.authors'
        ) | translate
      }}:</span
    >
    {{ ' ' }}
    @for (author of authors; track author; let last = $last) {
      <a
        class="hover:text-primary-text hover:underline"
        [dhpPersonLink]="author"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
        tabindex="0"
        role="link"
      >
        {{ author | formatAuthorName }}
      </a>
      {{ !last ? ', ' : '' }}
    }
  } @else {
    <span>{{ 'pages.articles.author' | translate }}</span>
  }
}
